import { useState, useCallback, useRef, useEffect } from 'react';
import { saveRedeemState, loadRedeemState } from './redeemPersistence';

export function useRedeemWizard() {
  const persisted = loadRedeemState() || {};
  const [step, setStep] = useState(persisted.step || 1);
  const [couponCode, setCouponCode] = useState(persisted.couponCode || '');
  const [templateData, setTemplateData] = useState(persisted.templateData || null);
  const [email, setEmail] = useState(persisted.email || '');
  const [companyName, setCompanyName] = useState(persisted.companyName || '');
  const [redemptionData, setRedemptionData] = useState(persisted.redemptionData || null);
  const [jwtToken, setJwtToken] = useState(persisted.jwtToken || null);
  const [connectedIntegrations, setConnectedIntegrations] = useState(
    new Set(persisted.connectedIntegrations || [])
  );
  const [selectedChannel, setSelectedChannel] = useState(persisted.selectedChannel || null); // 'whatsapp' | 'instagram' | null
  const [integrationId, setIntegrationId] = useState(persisted.integrationId || null);
  const [emailVerified, setEmailVerified] = useState(persisted.emailVerified || false);
  const integrationIdRef = useRef(persisted.integrationId || null);

  const goToStep = useCallback((n) => setStep(n), []);

  const markIntegrationConnected = useCallback((slug) => {
    setConnectedIntegrations((prev) => new Set([...prev, slug]));
  }, []);

  const allRequiredConnected = useCallback(() => {
    if (!templateData) return false;
    if (!selectedChannel) return false;
    const required = (templateData.required_integrations || []).filter((slug) => {
      if (slug === 'whatsapp' || slug === 'instagram') return slug === selectedChannel;
      return true;
    });
    return required.every((slug) => connectedIntegrations.has(slug));
  }, [templateData, connectedIntegrations, selectedChannel]);

  const setIntegrationIdBoth = useCallback((id) => {
    integrationIdRef.current = id;
    setIntegrationId(id);
  }, []);

  // Persistir el estado del wizard para sobrevivir recargas y el ida-y-vuelta al login.
  useEffect(() => {
    saveRedeemState({
      step, couponCode, templateData, email, companyName,
      redemptionData, jwtToken,
      connectedIntegrations: Array.from(connectedIntegrations),
      selectedChannel, integrationId, emailVerified,
    });
  }, [step, couponCode, templateData, email, companyName, redemptionData, jwtToken, connectedIntegrations, selectedChannel, integrationId, emailVerified]);

  return {
    step, goToStep,
    couponCode, setCouponCode,
    templateData, setTemplateData,
    email, setEmail,
    companyName, setCompanyName,
    redemptionData, setRedemptionData,
    jwtToken, setJwtToken,
    connectedIntegrations, setConnectedIntegrations, markIntegrationConnected,
    allRequiredConnected,
    selectedChannel, setSelectedChannel,
    integrationId, integrationIdRef, setIntegrationId: setIntegrationIdBoth,
    emailVerified, setEmailVerified,
  };
}
